import * as React from 'react';
import { TooltipDesktop } from '@cian/ui-kit/tooltip';
import { Button } from '@cian/ui-kit/button';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from '../../../common/state';
import { plural } from '@cian/utils';
import { makeSearch } from '../../../filters/state/search';
import { trackSearchButtonClick } from '../tracking';

interface IApplyFiltersButtonContainerProps {
  isAdvancedFiltersOpen?: boolean;
}

export function ApplyFiltersButtonContainer({ isAdvancedFiltersOpen }: IApplyFiltersButtonContainerProps) {
  const dispatch = useDispatch();
  const queryString = useSelector<IAppState, string | undefined>(state => state.filters.queryString) || '';
  const count = useSelector((state: IAppState) => state.filters.jsonQueryCount);
  const loading = useSelector((state: IAppState) => state.filters.jsonQueryCountRefresing);

  const tooltipDisabledByAppState = useSelector(
    (state: IAppState) =>
      state.isFetching ||
      state.filters.directionsModal.isVisible ||
      state.isMetroModalVisible ||
      state.filters.locationSwitcher.isLocationSwitcherOpened,
  );

  const title = React.useMemo(
    () => (count !== undefined ? `Показать ${count} ${plural(count, ['объект', 'объекта', 'объектов'])}` : ''),
    [count],
  );

  const tooltipDisabled = tooltipDisabledByAppState || isAdvancedFiltersOpen || title === '';

  const [shown, setShown] = React.useState(false);
  const countRef = React.useRef(count);

  const handleSearch = () => {
    trackSearchButtonClick(queryString);
    dispatch(makeSearch());
  };

  React.useEffect(() => {
    if (!loading && count !== countRef.current) {
      setShown(true);
    }
    countRef.current = count;
  }, [loading, count]);

  return (
    <TooltipDesktop
      placement="bottom"
      title={title}
      open={!tooltipDisabled && shown}
      theme="black"
      onClose={() => setShown(false)}
      onOpen={() => setShown(true)}
    >
      <Button theme="fill_primary" loading={loading} size="XS" onClick={handleSearch}>
        Найти
      </Button>
    </TooltipDesktop>
  );
}
